export const getters = {
  toastMessages: state => state.toastMessages,
};
